<div [id]="'div-' + description" class="canvas-container">
 
    <canvas #canvas id="canvas-{{ description }}" style="height: 150px;"></canvas>
</div>
